import React from "react";

//colors
import colorsLight from "../../assets/theme/light/colors";

import { useTranslation } from "react-i18next";

const StatusCell = ({ color = "", label = "" }) => {
  const { t } = useTranslation();

  const { statuses, timesheetStatusColors } = colorsLight;

  let colorValues = {};

  if (color === "success") {
    colorValues = statuses["success"];
  }

  if (color === "error") {
    colorValues = statuses["error"];
  }

  if(color === "pending"){
    colorValues = timesheetStatusColors["Pending"]
  }

  return (
    <span
      style={{
        backgroundColor: colorValues?.bgColor || colorValues?.backgroundColor,
        color: colorValues?.color,
        fontFamily: "poppins  !important",
        borderRadius: "5px",
        padding: "5px 20px",
        textAlign: "center",
      }}
    >
      {t(label)}
    </span>
  );
};

export default StatusCell;
